(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-bedding-customer-gallery"] && !Shopify.designMode) return;
  try {
    

function initMaryHomeCustomerGallery(root){
root.querySelectorAll('[data-mh-customer-gallery]').forEach(section=>{
if(section.dataset.galleryReady)return;
const track=section.querySelector('[data-customer-track]');
const prev=section.querySelector('[data-customer-prev]');
const next=section.querySelector('[data-customer-next]');
if(!track||!prev||!next)return;
section.dataset.galleryReady='true';
function move(direction){
const card=track.querySelector('.mh-customer-card');
const gap=parseFloat(getComputedStyle(track).columnGap)||18;
const distance=card?card.getBoundingClientRect().width+gap:track.clientWidth;
const max=track.scrollWidth-track.clientWidth;
const target=direction>0&&track.scrollLeft>=max-12?0:direction<0&&track.scrollLeft<=12?max:track.scrollLeft+direction*distance;
track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
}
prev.addEventListener('click',()=>move(-1));
next.addEventListener('click',()=>move(1));
});
}
initMaryHomeCustomerGallery(document);
document.addEventListener('shopify:section:load',event=>initMaryHomeCustomerGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-customer-gallery"] && !Shopify.designMode) return;
  try {
    

function initMaryHomeCustomerGallery(root){
root.querySelectorAll('[data-mh-customer-gallery]').forEach(section=>{
if(section.dataset.galleryReady)return;
const track=section.querySelector('[data-customer-track]');
const prev=section.querySelector('[data-customer-prev]');
const next=section.querySelector('[data-customer-next]');
if(!track||!prev||!next)return;
section.dataset.galleryReady='true';
function move(direction){
const card=track.querySelector('.mh-customer-card');
const gap=parseFloat(getComputedStyle(track).columnGap)||18;
const distance=card?card.getBoundingClientRect().width+gap:track.clientWidth;
const max=track.scrollWidth-track.clientWidth;
const target=direction>0&&track.scrollLeft>=max-12?0:direction<0&&track.scrollLeft<=12?max:track.scrollLeft+direction*distance;
track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
}
prev.addEventListener('click',()=>move(-1));
next.addEventListener('click',()=>move(1));
});
}
initMaryHomeCustomerGallery(document);
document.addEventListener('shopify:section:load',event=>initMaryHomeCustomerGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-fur-customer-gallery"] && !Shopify.designMode) return;
  try {
    

function initMaryHomeCustomerGallery(root){
root.querySelectorAll('[data-mh-customer-gallery]').forEach(section=>{
if(section.dataset.galleryReady)return;
const track=section.querySelector('[data-customer-track]');
const prev=section.querySelector('[data-customer-prev]');
const next=section.querySelector('[data-customer-next]');
if(!track||!prev||!next)return;
section.dataset.galleryReady='true';
function move(direction){
const card=track.querySelector('.mh-customer-card');
const gap=parseFloat(getComputedStyle(track).columnGap)||18;
const distance=card?card.getBoundingClientRect().width+gap:track.clientWidth;
const max=track.scrollWidth-track.clientWidth;
const target=direction>0&&track.scrollLeft>=max-12?0:direction<0&&track.scrollLeft<=12?max:track.scrollLeft+direction*distance;
track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
}
prev.addEventListener('click',()=>move(-1));
next.addEventListener('click',()=>move(1));
});
}
initMaryHomeCustomerGallery(document);
document.addEventListener('shopify:section:load',event=>initMaryHomeCustomerGallery(event.target));

  } catch(e) { console.error(e); }
})();
})();
